import React, { Component } from 'react'

class Header extends Component {
  state = {
    counter: 0
  }

  componentDidMount() {
    document.title = "Day three of react"
  }
  
  render() { 
    return (
      <header>
        <h1> 30 days of react </h1>
        <h2> getting sharp in react </h2>
        <h3> 2020 - the end is beginning </h3>
        <h4> state counter - {this.state.counter} </h4>
        <button onClick={() => this.setState({counter: this.state.counter + 1})}>
          add
        </button>
        <button onClick={() => this.setState({counter: this.state.counter > 0 ? this.state.counter - 1 : 0})}>
          subtract
        </button>
      </header>
    )
  }
}

class Main extends Component {
  render() {
    return (
      <main>
        <p>got to fill this with something</p>
        <ul>
          <li>make me better</li>
          <li>make me stronger</li>
          <li>make me prettier</li>
          <li>make me smarter</li>
          <li>make me richer</li>
          <li>make me wiser</li>
        </ul>
      </main>
    )
  }
}

class Footer extends Component {
  render() {
    return(
      <footer> 
        <p>Love is necessary. Please Love Me.❤️</p>
      </footer>
    )
  }
}

class Wrapper extends Component {
  render()  {
    return (
      <div id="wrapper">
        <Header />
        <Main />
        <Footer />
      </div>
    )
  }
}
export default Wrapper